import React from 'react';

import Container, { propTypes } from './container';
import Grid from './grid';

const ContainedGrid = ({ type, className, debug, children, ...other }) => (
  <Container {...{ className, type, debug }}>
    <Grid {...other}>{children}</Grid>
  </Container>
);

ContainedGrid.displayName = 'ContainedGrid';
ContainedGrid.propTypes = propTypes;

export default ContainedGrid;
